import { render, staticRenderFns } from "./ffswiper.vue?vue&type=template&id=452b19c2&"
import script from "./ffswiper.vue?vue&type=script&lang=js&"
export * from "./ffswiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports